<template>
    <UApp :locale="nb_no">
        <div class="w-screen h-screen flex-col bg-base-200 overflow-hidden relative" @dragend="cleanDrag">
            <topbar/>
            <router-view id="outer-router-view" class="router-view"/>
            <command-bar/>
            <dynamic-component-wrapper/>
            <document-preview-modal v-if="isDocumentPreviewModalOpen"/>
            <threads-popover v-if="commentPopupVisible" />
            <hotkeys-visualizer/>
            <ConfirmDialog/>
            <DynamicDialog/>
            <Toast/>
        </div>
    </UApp>
</template>

<script setup lang="ts">
import './index.css'
import '@/services/infrastructure/firebase.service'
import Topbar from '@/components/Topbar.vue'
import {isLoggedIn} from '@/services/infrastructure/auth.service'
import {bootstrapService} from '@/services/infrastructure/bootstrap.service'
import CommandBar from '@/commandbar/CommandBar.vue'
import DynamicComponentWrapper from '@/dynamic-component-loader/DynamicComponentWrapper.vue'
import {usePanelManager} from '@tritt/multipanel'
import DocumentPreviewModal from '@/document/DocumentPreviewModal.vue'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import HotkeysVisualizer from '@/hotkeys/HotkeysVisualizer.vue'
import {useSockets} from '@/services/infrastructure/socket.service'
import {watchEffect} from 'vue'
import {ConfirmDialog, DynamicDialog, Toast} from 'primevue'
import {registerNotificationHandlers} from '@/services/infrastructure/notification.service'
import {useToastNotification} from '@/toast/toast-notification.service'
import {nb_no} from '@nuxt/ui/locale'
import ThreadsPopover from '@/comment/ThreadsPopover.vue'
import {useComment} from '@/comment/comment.service'

// Auth and org initialization is now handled by BootstrapService in main.ts
// No longer need to listen for AUTH_STATE_CHANGE or call fetchUserOrgs here

const {commentPopupVisible} = useComment()
const {isDocumentPreviewModalOpen} = useDocumentPreviewModalService()
const {notificationRenderers} = useToastNotification()

registerNotificationHandlers(notificationRenderers)

const {setPanelDragSource, currentContentDragged} = usePanelManager()

const cleanDrag = () => {
    setPanelDragSource(undefined)
    currentContentDragged.value = undefined
}

// Initialize sockets when logged in and bootstrap is complete
watchEffect(async () => {
    if (isLoggedIn.value && bootstrapService.isReady.value) {
        await useSockets()
    }
})




</script>

<style>
@reference "@/index.css";
@reference "tailwindcss";

#app {
    @apply h-screen w-screen;

    #outer-router-view {
        height: calc(100vh - 54px);
    }
}

</style>